import React from 'react';
import Games from '../../components/games';

const GamesContainer = () => {
    return <Games />;
};

export default GamesContainer;
